import { ProviderType } from '../../models/ProviderDetails';

export interface careTeamRecords {
  pageNumber?: number;
  chipValue?: string;
  sortByValue?: string;
}
export interface CareTeamState {
  bookmarkedProviders: string[];
  careTeamProviderCount: number;
  showMaximumProviderLimitBanner: boolean;
  setShowMaximumProviderLimitBanner: (show: boolean) => void;
  setCareTeamProviderCount: (count: number) => void;
  clearShowMaximumProviderLimitBanner: () => void;
  addBookmark: (providerId: string) => void;
  removeBookmark: (providerId: string) => void;
  isBookmarked: (providerId: string) => boolean;
  setBookmarkedProviders: (providerIds: string[]) => void;
  careTeamRecords: careTeamRecords;
  setCareTeamRecords: (data: object) => void;
  clearCareTeamRecords: (defaultValues?: careTeamRecords) => void;
  providerDetails?: {
    providerName: string;
    providerType: ProviderType;
    primaryDegrees?: string;
    providerId: string;
    providerLocations?: Array<{
      address: string;
      latitude: number;
      longitude: number;
      providerId: string;
      providerName: string;
    }>;
    selectedAddressIndex?: number;
    currentIndex?: number;
    mobileRouteView?: boolean;
  };
  setProviderDetails: (data: Object) => void;
  clearProviderDetails: () => void;
  isCallDone: boolean;
  setIsCallDone: (done: boolean) => void;
}
export enum StoreKeys {
  CARE_TEAM_RECORDS = 'careTeamRecords',
  SET_CARE_TEAM_RECORDS = 'setCareTeamRecords',
  CLEAR_CARE_TEAM_RECORDS = 'clearCareTeamRecords',
  BOOKMARKED_PROVIDERS = 'bookmarkedProviders',
  SET_BOOKMARKED_PROVIDERS = 'setBookmarkedProviders',
  ADD_BOOKMARK = 'addBookmark',
  REMOVE_BOOKMARK = 'removeBookmark',
  IS_BOOKMARKED = 'isBookmarked',
  PROVIDER_DETAILS_FOR_DIRECTION = 'providerDetails',
  SET_PROVIDER_DETAILS_FOR_DIRECTION = 'setProviderDetails',
  CLEAR_PROVIDER_DETAILS_FOR_DIRECTION = 'clearProviderDetails',
}

export const initialState = {
  [StoreKeys.CARE_TEAM_RECORDS]: {
    chipValue: '',
    pageNumber: 1,
    sortByValue: 'firstNameAsc',
  },
  [StoreKeys.BOOKMARKED_PROVIDERS]: [],
  [StoreKeys.PROVIDER_DETAILS_FOR_DIRECTION]: {},
};
